import { getData } from '@gef-ui/middleware-api/facade';
import { MIDDLEWARE_NAME as OAUTH2_MIDDLEWARE_NAME } from '@gef-ui/middleware-api/middleware/oauth2/constants';
import { getBaseWithPostfix } from '@gef-ui/redux-common/selectors/urls';
export const loadMultipleVersions = (endpointArray, skipOauth, baseUrlSelector = getBaseWithPostfix)=>(dispatch)=>{
        endpointArray.forEach(({ name, endpoint })=>{
            dispatch(getData({
                endpoint: baseUrlSelector(endpoint),
                headers: {
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    Pragma: 'no-cache',
                    Expires: '0'
                },
                actionName: `get${name}Version`,
                middlewares: {
                    [OAUTH2_MIDDLEWARE_NAME]: {
                        skip: skipOauth
                    }
                },
                cache: {
                    cacheKey: name
                },
                meta: {
                    requestUuid: name
                }
            }));
        });
    };
